module.exports = __webpack_public_path__ + "img/portfolioImage.9418fe8a.png";